import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
    HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError, timer } from 'rxjs';
import { filter, switchMap, retry, take } from 'rxjs/operators';
import { OfflineService } from '../services/offline.service';
import { ToastService } from '../services/behavior/toast.service';

@Injectable()
export class OfflineInterceptor implements HttpInterceptor {

    constructor(
        private offlineService: OfflineService,
        private toastService: ToastService
    ) { }

    public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        return this.offlineService.isOnline$.pipe(
            filter(isOnline => isOnline),
            take(1),
            switchMap(() => {
                return next.handle(request).pipe(
                    retry({
                        delay: (error: HttpErrorResponse, retryCount: number) => {
                            if (retryCount > 5) {
                                this.toastService.error('Limite de tentativas excedido, erro de conexão persistente.', 3000);
                                return throwError(() => error);
                            }

                            if (error.status === 0 || !this.offlineService.isOnline$.value) {
                                console.warn(`[Offline Interceptor] Falha de conexão na URL: ${request.url}. Tentativa ${retryCount}/5. Tentando novamente em 2 segundos...`);

                                this.toastService.warning(`Não foi possível se conectar ao servidor. Tentando reconectar (${retryCount}/5)...`, 1800);
                                return timer(2000);
                            }

                            // Se o erro não for de rede (ex: 400, 500), não tenta novamente e lança o erro
                            return throwError(() => error);
                        }
                    })
                );
            })
        );
    }
}
